import { render } from "./KeyWarning.vue?vue&type=template&id=a9076e06&ts=true"
import script from "./KeyWarning.vue?vue&type=script&lang=ts"
export * from "./KeyWarning.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__